/**
 * Applies section membership changes (adopt / detach) via CanvasContext.
 */

import { useReactFlow } from "@xyflow/react";
import { useCallback } from "react";
import { useCanvas } from "../context/CanvasContext";
import { computeSectionMembershipChanges } from "../utils/sectionMembership";

export function useApplySectionMembership() {
  const { batchUpdateNodeParents } = useCanvas();
  const { getNodes, getInternalNode } = useReactFlow();

  const applySectionMembership = useCallback(
    (sectionId: string) => {
      const nodes = getNodes();
      const section = nodes.find((n) => n.id === sectionId);
      if (!section || section.type !== "section") return;

      const { adopt, detach } = computeSectionMembershipChanges(
        section,
        nodes,
        getInternalNode,
      );

      const updates = [
        ...adopt,
        ...detach.map((d) => ({
          nodeId: d.nodeId,
          parentId: d.parentId,
          position: d.position,
        })),
      ];

      if (updates.length > 0) {
        batchUpdateNodeParents(updates);
      }
    },
    [getNodes, getInternalNode, batchUpdateNodeParents],
  );

  return { applySectionMembership };
}
